"use client";

import { FEATURE_FLAG_KEYS } from "@agroproj/backend/convex/constants/featureFlags";
import { PlusIcon } from "lucide-react";
import type { Route } from "next";

import { ButtonLink } from "@/components/ui/button";
import { useConvexFeatureFlag } from "@/hooks/use-convex-feature-flag";

type ProjectsHeaderActionsProps = {
  organizationSlug: string;
};

export function ProjectsHeaderActions({ organizationSlug }: ProjectsHeaderActionsProps) {
  const { enabled } = useConvexFeatureFlag(FEATURE_FLAG_KEYS.PROJECT_PENDENCIES);

  return (
    <>
      {enabled ? (
        <ButtonLink
          size="sm"
          variant="outline"
          href={`/${organizationSlug}/projects/pendencies` as Route}
        >
          Pendências
        </ButtonLink>
      ) : null}
      <ButtonLink size="sm" href={`/${organizationSlug}/projects/new` as Route}>
        <PlusIcon />
        Novo projeto
      </ButtonLink>
    </>
  );
}
